import { AdminList, AdminDataGrid, GridColumn } from './shared';
/**
 * Suggestion List Component
 * Displays paginated list of AI-generated suggestions
 */

import {
  TextField,
  DateField,
  SearchInput,
  SelectInput,
  useRecordContext,
} from 'react-admin';
import { Chip } from '@mui/material';
import { semantic } from '@rekindle/shared/theme';
import { ListActions, UserEmailField } from './shared';

/**
 * Status color mapping for suggestions
 */
const STATUS_COLORS: Record<string, string> = {
  generated: semantic.info,
  pending: semantic.warning,
  planned: semantic.info,
  done: semantic.success,
  completed_with_reward: semantic.success,
  completed_without_reward: semantic.success,
};

/**
 * Custom field to display suggestion status with color coding
 */
function StatusField() {
  const record = useRecordContext();
  if (!record?.status) return null;

  const status = record.status.toLowerCase();
  const color = STATUS_COLORS[status] || STATUS_COLORS.generated;

  return (
    <Chip
      label={record.status.replaceAll('_', ' ')}
      size="small"
      sx={{
        backgroundColor: color,
        color: 'white',
        textTransform: 'capitalize',
      }}
    />
  );
}

/**
 * Filters for suggestion list
 */
const suggestionFilters = [
  <SearchInput key="q" source="q" alwaysOn placeholder="Search suggestions..." />,
  <SelectInput
    key="status"
    source="status"
    label="Status"
    choices={[
      { id: 'generated', name: 'Generated' },
      { id: 'pending', name: 'Pending' },
      { id: 'planned', name: 'Planned' },
      { id: 'done', name: 'Done' },
      { id: 'completed_with_reward', name: 'Completed with reward' },
      { id: 'completed_without_reward', name: 'Completed without reward' },
    ]}
  />,
];

export function SuggestionList() {
  return (
    <AdminList
      filters={suggestionFilters}
      actions={<ListActions />}
      sort={{ field: 'createdAt', order: 'DESC' }}
      perPage={25}
    >
      <AdminDataGrid bulkActionButtons={false} rowClick="show" omit={['id']}>
        <TextField source="id" label="ID" />
        <TextField source="title" label="Title" />
        <GridColumn label="User" source="userEmail"><UserEmailField /></GridColumn>
        <GridColumn label="Status" source="status"><StatusField /></GridColumn>
        <TextField source="category" label="Category" />
        <DateField source="createdAt" label="Generated" showTime />
      </AdminDataGrid>
    </AdminList>
  );
}
